import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    'dropdown',
    'toggle'
  ]

  static values = {
    isOpen: Boolean
  }

  connect() {
    window.addEventListener('click', this.close.bind(this))
  }

  disconnect() {
    window.removeEventListener('click', this.close.bind(this))
  }

  close(e) {
    if (this.element.contains(e.target)) { return }

    this.dropdownTarget.classList.remove('active')
    this.isOpenValue = false
  }

  toggle(e) {
    e.preventDefault()
    this.dropdownTarget.classList.toggle('active')

    if (this.dropdownTarget.classList.contains('active')) {
      this.isOpenValue = true
    } else {
      this.isOpenValue = false
    }
  }
}
